import React from 'react';

export default function Logo({_width,_height, _marginLeft,_marginTop, name, _color }) {
  return (
    <>

      <img src={`../../../image/${name}`} alt=""  style={{width: _width, color: _color, height: _height, marginLeft: _marginLeft, marginTop:  _marginTop}} />
    </>
  );
}
